import { render, staticRenderFns } from "./DevFailReason.vue?vue&type=template&id=2e38af2f&scoped=true&"
import script from "./DevFailReason.vue?vue&type=script&lang=js&"
export * from "./DevFailReason.vue?vue&type=script&lang=js&"
import style0 from "./DevFailReason.vue?vue&type=style&index=0&id=2e38af2f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e38af2f",
  null
  
)

export default component.exports